import { render, staticRenderFns } from "./PancreasWhole.vue?vue&type=template&id=0afe6d98"
import script from "./PancreasWhole.vue?vue&type=script&lang=ts"
export * from "./PancreasWhole.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports